export const BANK_CODE = [
  { name: 'EasyPaisa', id: 0 },
  { name: 'JazzCash', id: 1 },
  { name: 'ABHI FINANCE SERVICES LIMITED', id: 2 },
  { name: 'AFT', id: 3 },
  { name: 'AFT IBFT', id: 4 },
  { name: 'Advans', id: 5 },
  { name: 'Al Meezan Investment Management Limited', id: 6 },
  { name: 'AlHabib', id: 7 },
  { name: 'Albarka', id: 8 },
  { name: 'Alfalah', id: 9 },
  { name: 'Allied', id: 10 },
  { name: 'Apna', id: 11 },
  { name: 'Askari', id: 12 },
  { name: 'BOK', id: 13 },
  { name: 'BYKEA', id: 14 },
  { name: 'BankIslami', id: 15 },
  { name: 'Burj', id: 16 },
  { name: 'Central Directorate of National Savings', id: 17 },
  { name: 'Central Directorate of National Savings (CDNS)', id: 18 },
  {
    name: 'Central Directorate of National Savings (CDNS) – 1IBFT IMD Addition',
    id: 19,
  },
  { name: 'Citi', id: 20 },
  { name: 'DubaiIslamic', id: 21 },
  { name: 'EZ wage', id: 22 },
  { name: 'FINCA', id: 23 },
  { name: 'FINJA', id: 24 },
  { name: 'FWBL', id: 25 },
  { name: 'Faysal', id: 26 },
  { name: 'First Microfinance Bank', id: 27 },
  { name: 'HBL', id: 28 },
  { name: 'HBL ASSET MANAGEMENT', id: 29 },
  { name: 'Habib Metro Bank – Bulk 1IBFT', id: 30 },
  { name: 'HabibMetro', id: 31 },
  { name: 'Humrah Financial Services', id: 32 },
  { name: 'ICBC', id: 33 },
  { name: 'JS', id: 34 },
  { name: 'KASB', id: 35 },
  { name: 'KBL', id: 36 },
  { name: 'KEENU', id: 37 },
  { name: 'KEENU Bank', id: 38 },
  { name: 'KEENU – IMD and 1IBFT Screen Addition', id: 39 },
  { name: 'Keenu1', id: 40 },
  { name: 'MCB', id: 41 },
  { name: 'MCB-Arif Habib', id: 42 },
  { name: 'MIB', id: 43 },
  { name: 'Meezan', id: 44 },
  { name: 'MobilinkBank Pakistan', id: 45 },
  { name: 'NAYAPAY', id: 46 },
  { name: 'NBP', id: 47 },
  { name: 'NBP Fund Management Limited', id: 48 },
  { name: 'NBP1', id: 49 },
  { name: 'NIB', id: 50 },
  { name: 'NRSP', id: 51 },
  { name: 'National Bank', id: 52 },
  { name: 'Numbers Private Limited', id: 53 },
  { name: 'PayMax', id: 54 },
  { name: 'PayMax1', id: 55 },
  { name: 'PunjabBank', id: 56 },
  { name: 'SADAPAY', id: 57 },
  { name: 'SCB', id: 58 },
  { name: 'SEEDCREED Financial Services Limited', id: 59 },
  { name: 'SIMPAISA', id: 60 },
  { name: 'SIND', id: 61 },
  { name: 'Samba', id: 62 },
  { name: 'Silk', id: 63 },
  { name: 'SindhBank', id: 64 },
  { name: 'Soneri', id: 65 },
  { name: 'Summit', id: 66 },
  { name: 'TAG', id: 67 },
  { name: 'TezPAy', id: 68 },
  { name: 'UBL', id: 69 },
  { name: 'UPaisa', id: 70 },
  { name: 'Waseela', id: 71 },
  { name: 'Waseela bank', id: 72 },
  { name: 'ZTBL1', id: 73 },
  { name: 'Zarai Taraqiati Bank', id: 74 },
];
